import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, cloudLightest} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  header: {
    marginBottom: indent / 4,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  timestampContainer: {
    marginBottom: indent * 1.5,
  },
  headerAvatar: {
    marginRight: 10,
  },
  headerGreeting: {
    flex: 1,
    marginLeft: 10,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  headerGreetingText: {
    color: black,
    fontSize: 22,
    lineHeight: 28,
    ...getFontFamily('bold'),
  },
  section: {
    marginBottom: 20,
  },
  webSectionSpacing: {
    marginBottom: 12,
  },
  sectionTransparent: {
    backgroundColor: 'transparent',
  },
  sectionOpaque: {
    backgroundColor: cloudLightest,
  },
  loading: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingCard: {
    height: 60,
  },
  loadingSection: {
    height: 100,
  },
});
